import { Alert, Button } from "@growtherapy/sprout-ui";
import { useContactUs } from "../../../useContactUs";
import { useTranslate } from "@growtherapy/i18n";

export function SeparateAccountCallout() {
  const t = useTranslate();
  const { pageUrl } = useContactUs();

  return (
    <Alert
      use="info"
      icon={null}
      heading={t("telehealth-core:introRoom.wantASeparateAccount")}
      actions={
        <Button
          className="flex-shrink-0"
          onClick={() => {
            window.open(pageUrl, "_blank");
          }}
        >
          {t("telehealth-core:core.contactUs")}
        </Button>
      }
    >
      {t("telehealth-core:introRoom.givenYouAreNowOver18")}
    </Alert>
  );
}
